import { guardedFetch } from "./utils";
import type { ErrorHandlingOptions } from "../helpers/api/utils";
import type { ApiResponse } from "../../types/api";
import API_CONSTANTS from "../constants/api";

export type ConfigResponse = ApiResponse & {
  config: object;
};

export async function getConfig(domain: string, errorOptions: ErrorHandlingOptions = {}): Promise<ConfigResponse> {
  const url = `${API_CONSTANTS.frontendBaseUrl}/v1/config/${domain}`;
  const result = await guardedFetch(url, {
    method: "GET"
  }, errorOptions);
  return (await result.json()) as ConfigResponse;
}
